import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import './number_field.css';

var _ref = React.createElement(
	'label',
	null,
	React.createElement(
		'span',
		null,
		'Qty:'
	)
);

var NumberField = function (_Component) {
	_inherits(NumberField, _Component);

	function NumberField(props) {
		_classCallCheck(this, NumberField);

		var _this = _possibleConstructorReturn(this, (NumberField.__proto__ || Object.getPrototypeOf(NumberField)).call(this, props));

		_this.state = {
			value: 1
		};

		_this.handleChange = _this.handleChange.bind(_this);
		return _this;
	}

	_createClass(NumberField, [{
		key: 'handleChange',
		value: function handleChange(event) {
			this.setState({ value: event.target.value });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    title = _props.title,
			    note = _props.note,
			    required = _props.required,
			    itemAction = _props.itemAction,
			    quantity = _props.quantity;

			return React.createElement(
				'div',
				{ className: 'NumberField' },
				_ref,
				React.createElement('input', { type: 'number', min: '1', value: this.state.value, onChange: function onChange(e) {
						_this2.handleChange(e);itemAction(e.currentTarget.value);
					} })
			);
		}
	}]);

	return NumberField;
}(Component);

export default NumberField;